import { render, staticRenderFns } from "./addInfo.vue?vue&type=template&id=3837442c&scoped=true&%3Ais=view&transition=fade&transition-mode=out-in&"
import script from "./addInfo.vue?vue&type=script&lang=js&"
export * from "./addInfo.vue?vue&type=script&lang=js&"
import style0 from "./addInfo.vue?vue&type=style&index=0&id=3837442c&lang=less&scoped=true&"
import style1 from "./addInfo.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3837442c",
  null
  
)

export default component.exports